import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "hidden", "dropdown", "item"]

  connect() {
    this._closeHandler = this._closeIfOutside.bind(this)
  }

  open() {
    this.dropdownTarget.classList.remove("hidden")
    document.addEventListener("click", this._closeHandler)
  }

  filter() {
    const q = this.inputTarget.value.toLowerCase()
    this.itemTargets.forEach(item => {
      item.classList.toggle("hidden", !item.textContent.toLowerCase().includes(q))
    })
    this.dropdownTarget.classList.remove("hidden")
  }

  select(event) {
    const item = event.currentTarget
    this.inputTarget.value = item.dataset.name
    this.hiddenTarget.value = item.dataset.id
    this.dropdownTarget.classList.add("hidden")
    document.removeEventListener("click", this._closeHandler)
  }

  _closeIfOutside(event) {
    if (!this.element.contains(event.target)) {
      this.dropdownTarget.classList.add("hidden")
      document.removeEventListener("click", this._closeHandler)
    }
  }
}
